import { type FC } from 'react';
import {
  FloppyDisk
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconFloppyDiskProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconFloppyDisk: FC<UiIconFloppyDiskProps> = (props) => {
  return (
    <UiIcon
      IconComponent={FloppyDisk}
      {...props}
    />
  );
};
